import { ApiPropertyProject } from '../ApiSchemas';

export const isProjectEditable = (project: Pick<ApiPropertyProject, 'status'> | null | undefined) => !!project && project?.status !== 'completed';
